var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScience = function SvgScience(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M21 22.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M35.35 35.35c3.57-3.553.035-12.88-7.875-20.825C19.53 6.615 10.203 3.08 6.65 6.65c-3.57 3.552-.035 12.88 7.875 20.825 7.945 7.91 17.273 11.445 20.825 7.875"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M27.475 27.475C35.385 19.53 38.92 10.202 35.35 6.65c-3.552-3.57-12.88-.035-20.825 7.875C6.615 22.47 3.08 31.797 6.65 35.35c3.553 3.57 12.88.035 20.825-7.875"
  })));
};
export default SvgScience;